module.exports = __webpack_public_path__ + "static/media/capital1.985eebb2.svg";